import { useRef } from 'react';

import { useMouseEvents } from './useMouseEvents';
import { useScrollEvents } from './useScrollEvents';

interface UseTooltipEventsParams {
  updateTooltipState: (clientX: number, clientY: number) => void;
}

const mouseThrottleDelay = 16;
const scrollThrottleDelay = 50;

export const useTooltipEvents = ({
  updateTooltipState,
}: UseTooltipEventsParams) => {
  // Shared cursor position for both mouse and scroll events
  const lastPositionRef = useRef<{ x: number; y: number } | null>(null);

  useMouseEvents({
    updateTooltipState,
    throttleDelay: mouseThrottleDelay,
    lastPositionRef,
  });

  useScrollEvents({
    updateTooltipState,
    throttleDelay: scrollThrottleDelay,
    lastPositionRef,
  });
};
